import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AppResource } from './app.resource';
import { Resource } from './resources/resource';
import { AppInsightsService } from './shared/services/app-insight.service';
import { WINDOW, WindowRef } from './shared/services/window.service';
import { GtmService } from './shared/services/google-tag-manager.service';

interface CustomWindow extends Window {
  matomoHostUrl: string;
  matomoSiteId: number;
  tarteaucitron: {
    user: {
      matomoSiteId: number;
      matomoHostUrl: string;
    };
  };
}

import { ToastModule } from 'primeng/toast';
import { VyvToastComponent } from './shared/components/vyv-toast/vyv-toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, VyvToastComponent],
  templateUrl: './app.component.html',
  styles: [],
})
export class AppComponent implements OnInit {
  title = 'template-parcours';
  resource: Resource;
  private windowRef = inject<WindowRef>(WINDOW);

  constructor(
    private config: PrimeNGConfig,
    private appInsightService: AppInsightsService,
    private router: Router,
    private gtmService: GtmService,
    protected resources: AppResource,
  ) {
    this.resource = resources['resource'];
    this.preloadSVG();
  }

  ngOnInit(): void {
    this.config.setTranslation(this.resource.primeng);

    this.gtmService.init(environment.googleTagManagerId);
    this.trackPageViews();
  }

  private trackPageViews(): void {
    this.gtmService.pushEvent('page_view', {
      page_path: this.router.url,
      page_title: document.title,
    });
  }

  loadScript(_url: string) {
    const node = document.createElement('script');
    node.src = _url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0]?.appendChild(node);
  }

  @HostListener('document:appInsights_allowed', ['$event'])
  onAppInsightsAllowed(ev: Event) {
    this.appInsightService.initAppInsights();
  }

  @HostListener('document:appInsights_disallowed', ['$event'])
  onAppInsightsDisallowed(ev: Event) {
    this.appInsightService.disableAppInsights();
  }

  preloadSVG() {
    const svgs = [this.resource.header.logo];
    const frag = new Array<Node>();

    svgs.forEach((item) => {
      const res = document.createElement('link');
      res.rel = 'preload';
      res.type = 'image/svg+xml';
      res.as = 'image';
      res.href = item;
      frag.push(res);
    });

    document.getElementsByTagName('head')[0]?.append(...frag);
  }
}
